"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SortDir = exports.HelpIndexes = exports.PrimaryProduct = exports.Locales = exports.Applications = exports.UserType = void 0;
var UserType;
exports.UserType = UserType;

(function (UserType) {
  UserType["Staff"] = "staff";
  UserType["Client"] = "client";
  UserType["Admin"] = "admin";
})(UserType || (exports.UserType = UserType = {}));

var Applications;
exports.Applications = Applications;

(function (Applications) {
  Applications["Onvio"] = "Onvio";
  Applications["FirmManagement1"] = "FirmManagement1";
  Applications["FirmManagement2"] = "FirmManagement2";
  Applications["FirmManagement3"] = "FirmManagement3";
  Applications["Tax"] = "Tax";
  Applications["Workpapers"] = "Workpapers";
  Applications["TrialBalance"] = "TrialBalance";
  Applications["CheckpointEngage"] = "CheckpointEngage";
  Applications["Accounting"] = "Accounting";
  Applications["Accounts"] = "Accounts";
  Applications["CompanyFormation"] = "CompanyFormation";
  Applications["Secretarial"] = "Secretarial";
  Applications["TimeAndBilling"] = "TimeAndBilling";
  Applications["Recibos"] = "Recibos";
  Applications["Samba"] = "Samba";
  Applications["Advisory"] = "Advisory";
  Applications["VAT"] = "VAT";
})(Applications || (exports.Applications = Applications = {}));

var Locales;
exports.Locales = Locales;

(function (Locales) {
  Locales["enAU"] = "en-AU";
  Locales["enUS"] = "en-US";
  Locales["enGB"] = "en-GB";
  Locales["enCA"] = "en-CA";
  Locales["esAR"] = "es-AR";
  Locales["frCA"] = "fr-CA";
  Locales["nlNL"] = "nl-NL";
  Locales["ptBR"] = "pt-BR";
})(Locales || (exports.Locales = Locales = {}));

var PrimaryProduct;
exports.PrimaryProduct = PrimaryProduct;

(function (PrimaryProduct) {
  PrimaryProduct["Onvio"] = "onvio";
  PrimaryProduct["Onbalance"] = "samba";
})(PrimaryProduct || (exports.PrimaryProduct = PrimaryProduct = {}));

var HelpIndexes;
exports.HelpIndexes = HelpIndexes;

(function (HelpIndexes) {
  HelpIndexes["Onvio"] = "onvio-{lang}";
  HelpIndexes["Onbalance"] = "onbalance-{lang}";
  HelpIndexes["OnvioReleaseNotes"] = "onvio-rsnotes-{lang}";
  HelpIndexes["OnvioInternal"] = "onvio-internal-{lang}";
  HelpIndexes["OnbalanceInternal"] = "onbalance-internal-{lang}";
})(HelpIndexes || (exports.HelpIndexes = HelpIndexes = {}));

var SortDir;
exports.SortDir = SortDir;

(function (SortDir) {
  SortDir["Asc"] = "asc";
  SortDir["Desc"] = "desc";
})(SortDir || (exports.SortDir = SortDir = {}));
